module.exports = function() {
  return new Worker(__webpack_public_path__ + "f5ebac38cd17be629d87.worker.js");
};